var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBitcoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.114 27.58c7.5 1.871 15.097-2.693 16.967-10.193 1.87-7.5-2.694-15.098-10.195-16.968C10.388-1.451 2.791 3.114.922 10.615c-1.87 7.5 2.694 15.096 10.192 16.966Zm4.804-19.566c2.044.178 3.663.805 3.845 2.68.136 1.372-.437 2.196-1.355 2.664 1.512.362 2.46 1.259 2.274 3.272-.229 2.5-2.091 3.172-4.753 3.327l.002 2.626-1.583.001-.002-2.59c-.41 0-.83-.003-1.265-.012l.003 2.603-1.582.002-.003-2.631c-.152 0-.305-.002-.46-.004-.222-.002-.445-.004-.67-.004l-2.061.001.313-1.89s1.17.017 1.15-.001c.449-.002.567-.323.595-.525l-.003-4.151H10.53a1.257 1.257 0 0 0-.167-.012l-.003-2.963c-.061-.321-.27-.693-.912-.693.02-.021-1.15.002-1.15.002l-.001-1.691 2.183-.001v.008c.329 0 .666-.007 1.008-.014l-.002-2.6 1.583-.002.002 2.55a63.61 63.61 0 0 1 1.264-.019l-.002-2.532 1.583-.002.002 2.601ZM13.426 18.07c1.296.017 4.13.054 4.127-1.75-.002-1.844-2.723-1.777-4.052-1.745-.148.004-.28.007-.387.007l.002 3.486.31.002Zm3.386-6.666c.001 1.64-2.358 1.603-3.44 1.586l-.26-.003-.002-3.161c.09 0 .2-.003.325-.007 1.107-.03 3.376-.092 3.377 1.585Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoin);
export default __webpack_public_path__ + "static/media/bitcoin.f36abea1b30cb03a1375f959ff4d03a0.svg";
export { ForwardRef as ReactComponent };